import { ownsClientDetailAction } from "store/slices/clientDetailOwnership";
import { useStore as useClientDetailStore } from "react-redux";
import PropTypes from "prop-types";
import { getNotificationAppointmentTarget } from "pages/calendar/notificationAppointmentTarget";
import React, { useEffect, useState } from 'react';
import config from "../../../../../config";
import 'moment';
import { ClientDetailApi, ClientDetailTab, OpenClientDetailModal } from 'store/slices/clientSlice';
import { useSelector, useDispatch } from 'react-redux';
import 'store/slices/clientvoucherSlice';
import 'store/slices/clientmembershipSlice';
import 'store/slices/clientnoteSlice';
import 'store/slices/clientdocumentSlice';
import 'store/slices/clientinvoiceSlice';
import 'store/slices/clientphotoSlice';
import { AddAppointmentForm, AppointmentDetailModal, RescheduleAppointmentForm, ShowLoadingSpinner, appointmentDetailApi } from 'store/slices/appointmentSlice';
import { ClientchatGridViewApi } from 'store/slices/clientChatSlice';
import { NotificationListApi, NotificationToCalendar, NotificationUpdateApi, UpcomingNotifyDetailDrawer } from 'store/slices/notificationSlice';
import { useLocation, useNavigate } from 'react-router';
import MoonLoader from "react-spinners/MoonLoader";
import 'store/slices/calendarSlice';
import { usercheckAccess } from 'helpers/Functions';
import { AddBusytimeForm, EditBusytimeForm } from 'store/slices/busytimeSlice';
import 'store/slices/staffSlice';
import 'store/slices/salonSlice';
import { sweatalert } from 'component/Sweatalert2';
import customToast from 'component/Toastr';
import { useTranslation } from 'react-i18next';
import { canOpenNotificationAppointment, notificationRows, toNotificationViewModel } from '../notificationViewModel';
import { formatNotificationAge, notificationReceivedAt } from '../notificationDate';
import NotificationSchedule from '../NotificationSchedule';


const AllNotificationList = (props) => {
  const dispatch = useDispatch();
  const detailStore = useClientDetailStore();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [loader, setLoader] = useState({});
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(timer);
  }, []);
  const views = props && props.view;
  const objectData = notificationRows(views);
  useSelector(state => state.notification.isUpcomingNotifyDetailTab);
  useSelector(state => state.client.isClientDetailTab);
  useSelector(state => state.calendar.isRangeInfo);
  useSelector(state => state.calendar.isTabView);
  const auth = useSelector((state) => state.auth);
  const currentUser = auth.user;
  const role_id = currentUser && currentUser.role_id;
  const single_staff_access = usercheckAccess("calendar_view", currentUser);
  const singleStaffAccess = role_id === 8 ? '' : (single_staff_access && currentUser && currentUser.is_owner === 0) ? 1 : '';

  return (
    <div>
      {objectData && objectData.length > 0 ? (
        <>
          {Object.keys(objectData).map((item, index) => {
            const notification = toNotificationViewModel(objectData[item]);
            const canOpenAppointment = canOpenNotificationAppointment(notification);
            const id = notification.actionId || "";
            const profilePhotoUrl = notification.client.profile_photo_url || "";
            const profilePhotoUrlMessage = notification.messageClient.profile_photo_url || "";
            const message_client_first_name = notification.messageClient.first_name || "";
            const message_client_last_name = notification.messageClient.last_name || "";
            const first_name = notification.client.first_name || "";
            const last_name = notification.client.last_name || "";
            const iconUrl = canOpenAppointment ? "eye-round.png" : !notification.isAppointmentNotification && notification.clientId ? "reply-round.png" : "";
            const receivedAt = notificationReceivedAt(objectData[item]);
            const datedifference = formatNotificationAge(receivedAt, now);
            const service_name = notification.serviceName;
            const messages = notification.messageText.replace(/\r?\n|\r/g, ' ');
            const is_seen = objectData[item] && objectData[item].is_seen == 0 ? 0 : 1;
            const staff_first_name = notification.appointment.staff && notification.appointment.staff.first_name ? notification.appointment.staff.first_name : "";
            const staff_last_name = notification.appointment.staff && notification.appointment.staff.last_name ? notification.appointment.staff.last_name : "";
            const message_client_id = notification.clientId;
            void (objectData[item] && objectData[item].appointment && objectData[item].appointment.staff ? objectData[item].appointment.staff : "");
            void (objectData[item] && objectData[item].appointment && objectData[item].appointment.staff_id ? objectData[item].appointment.staff_id : "");
            let notification_appointment_id = notification.appointmentId;
            let notification_client_id = notification.clientId;
            let notification_showdate = getNotificationAppointmentTarget(objectData[item]).showdate;
            let notification_start_date = getNotificationAppointmentTarget(objectData[item]).showstartdate;
            let notification_end_date = getNotificationAppointmentTarget(objectData[item]).showenddate;

            return (
              <div className="box-image-cover notification-boxs w-100 mx-0 py-md-4 py-3 text-start" style={{ background: `${is_seen == 1 ? "#fff" : "#f9f6f4"}`,marginBottom:`${index === objectData.length - 1 ? "43px" : "0px"}` }} key={index}>
                <div className="row align-items-center">
                  <div className="col-xxl-9 col-md-8 mb-md-0 mb-2">
                    <div className="d-flex align-items-center">
                      <div className="text-center">
                        {objectData[item] && objectData[item].type && objectData[item].type === "online_booking" ? (
                          <>
                            {profilePhotoUrl ? (
                              <img src={profilePhotoUrl} alt="" className="rounded-circle wh-40 profile-image-obj mwh-40" />
                            ) : (
                              <div className="user-initial text-uppercase profile-image-height wh-40 mwh-40">{first_name && last_name ? first_name.charAt(0) + "" + last_name.charAt(0) : ""}</div>
                            )}
                          </>
                        ) : (
                          <>
                            {profilePhotoUrlMessage ? (
                              <img src={profilePhotoUrlMessage} alt="" className="rounded-circle wh-40 profile-image-obj mwh-40" />
                            ) : (
                              <div className="user-initial text-uppercase profile-image-height wh-40 mwh-40">{message_client_first_name && message_client_last_name ? message_client_first_name.charAt(0) + "" + message_client_last_name.charAt(0) : ""}</div>
                            )}
                          </>
                        )}
                      </div>
                      <div className="ps-3">
                        <div>
                          {objectData[item] && objectData[item].type && objectData[item].type === "online_booking" ? (
                            <h6 className='fw-semibold mb-0'>{`${first_name} ${last_name}`}</h6>
                          ) : (
                            <h6 className='fw-semibold mb-0'>{`${message_client_first_name} ${message_client_last_name}`}</h6>
                          )}
                        </div>
                        {objectData[item] && objectData[item].type && objectData[item].type === "online_booking" ? (
                          <div>
                            <p className='fw-semibold mb-0'>{`${service_name} with ${staff_first_name + " " + staff_last_name}`}</p>
                            <NotificationSchedule row={objectData[item]} />
                            {notification.invoiceNumber && <p className='mb-0'>Invoice #{notification.invoiceNumber}</p>}
                            <div>
                              <time className='color-wine' dateTime={receivedAt}>{datedifference}</time>
                            </div>
                            <p className={notification.event_type === "appointment_cancelled" ? "mb-0 text-danger" : "mb-0"}>{t(notification.appointmentEventLabel)}</p>
                          </div>
                        ) : (
                          <div>
                            <p className='fw-semibold mb-0'>{messages}</p>
                            {notification.isWaitlistNotification && <NotificationSchedule row={objectData[item]} />}
                            <div>
                              <time className='color-wine' dateTime={receivedAt}>{datedifference}</time>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-md-4 ps-md-0 d-flex justify-content-end align-items-center">
                    <>
                      {iconUrl ? (
                          <span
                            onClick={async () => {
                              setLoader((prevLoader) => ({ ...prevLoader, [index]: true })); // Set loader to true for the clicked index
                              dispatch(NotificationUpdateApi({ id, is_seen: 1 })).then((action) => {
                                if (action.meta.requestStatus === "fulfilled") {
                                  dispatch(NotificationListApi());
                                }
                              });
                              if (notification.isAppointmentNotification) {
                                dispatch(NotificationToCalendar(objectData[item]));
                                if (location && location.pathname === "/calendar") {
                                  try {
                                    dispatch(ShowLoadingSpinner(true));
                                    dispatch(AddAppointmentForm(""));
                                    dispatch(AddBusytimeForm(""));
                                    dispatch(EditBusytimeForm(""));
                                    dispatch(RescheduleAppointmentForm(""));
                                    dispatch(
                                      appointmentDetailApi({
                                        id: notification_appointment_id,
                                        client_id: notification_client_id,
                                        showdate: notification_showdate,
                                        showstartdate: notification_start_date,
                                        showenddate: notification_end_date,
                                        page_name: "calendar",
                                        singlestaffaccess: singleStaffAccess
                                      }),
                                    ).then((action) => {
                                      setLoader((prevLoader) => ({ ...prevLoader, [index]: false }));
                                      if (action.meta.requestStatus === "fulfilled" && action.payload && action.payload.id) {
                                        dispatch(AppointmentDetailModal(true));
                                        setTimeout(() => {
                                          dispatch(AppointmentDetailModal("open"));
                                        }, config.modalOpenTimeOut);
                                      } else if (action.meta.requestStatus === "fulfilled") {
                                        dispatch(ShowLoadingSpinner(false));
                                        customToast.error(t("Unable to load the appointment details."));
                                      } else if (action.meta.requestStatus === "rejected") {
                                        if (action.payload.status === 422) {
                                          let error = action.payload;
                                          const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
                                          sweatalert({
                                            title: message.errors.document[0],
                                            text: message.errors.document,
                                            icon: "error",
                                          });
                                        }
                                      }
                                    })
                                  } catch (error) {
                                    console.log(error);
                                    customToast.error('Sorry there was a problem, please refresh your browser');
                                    dispatch(UpcomingNotifyDetailDrawer(""));
                                    setLoader((prevLoader) => ({ ...prevLoader, [index]: false })); // Set loader back to false after the action is completed
                                    dispatch(ShowLoadingSpinner(false));
                                  }
                                } else {
                                  setTimeout(() => {
                                    setLoader((prevLoader) => ({ ...prevLoader, [index]: false })); // Set loader back to false after the action is completed
                                    navigate(config.basePath + "/calendar");
                                    dispatch(UpcomingNotifyDetailDrawer(""));
                                  }, 1000)
                                }
                              } else if (notification.clientId) {
                                dispatch(ClientDetailTab("chatmessages"));
                                dispatch(ClientDetailApi({ id: message_client_id })).then((action) => {
      if (!ownsClientDetailAction(detailStore.getState().client, action)) return;
                                  setLoader((prevLoader) => ({ ...prevLoader, [index]: false })); // Set loader back to false after the action is completed
                                  dispatch(UpcomingNotifyDetailDrawer(""));
                                  if (action.meta.requestStatus === "fulfilled") {
                                    dispatch(ClientchatGridViewApi({ client_id: message_client_id }));
                                    dispatch(OpenClientDetailModal(true));
                                    setTimeout(() => {
                                      if (!ownsClientDetailAction(detailStore.getState().client, action)) return;
                        dispatch(OpenClientDetailModal("open"));
                                    }, config.modalOpenTimeOut);
                                  }
                                });
                              }
                            }}>
                            {loader[index] ? (
                              <MoonLoader color="#8c1c4d" size="22px" />
                            ) : (
                              <img src={config.imagepath + iconUrl} alt="" className="rounded-circle wh-25 profile-image-obj" />
                            )}
                          </span>
                      ) : ""}
                    </>
                  </div>
                </div>
              </div>
            )
          })}
        </>
      ) : (
        <div className="complete-box text-center d-flex flex-column justify-content-center mt-5">
          <div className="complete-box-wrp text-center">
            {/* <img src={config.imagepath + "bellnotifications.png"} alt="" className="mb-md-4 mb-3" /> */}
            <img src={config.imagepath + "notification-bell.png"} alt="" className="mb-md-4 mb-3" />
            <h5 className="mb-2 fw-semibold" style={{ color: 'rgb(151,136,136)' }}>{t("No notification found")}</h5>
          </div>
        </div>
      )}
    </div>
  )
}

AllNotificationList.propTypes = {
  view: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default AllNotificationList;
